// import React, { Fragment, useState } from 'react'
// import Grid from '@material-ui/core/Grid'
// import { withStyles } from '@material-ui/core/styles'
// import PropTypes from 'prop-types'
// import Typography from '@material-ui/core/Typography'
// import CircularProgress from '@material-ui/core/CircularProgress'
// import FileDownloadIcon from '@material-ui/icons/FileDownload'
// import Select from 'react-select'
// import TextField from '@material-ui/core/TextField'
// import Button from '@material-ui/core/Button'
// import Card from '@material-ui/core/Card'
// import CardHeader from '@material-ui/core/CardHeader'
// import CardContent from '@material-ui/core/CardContent'
// import CardActions from '@material-ui/core/CardActions'
// import Divider from '@material-ui/core/Divider'
// import { Checkbox } from '@material-ui/core'
// import gql from 'graphql-tag'
// import { Query, withApollo } from 'react-apollo'
// import getLoginId from '../../../utils/getLoginId'

// const GET_BILLING_MODE = gql`
//   query {
//     billingMode: getAllBillingMode {
//       id
//       billingMode
//     }
//   }
// `
// const GET_DEVICE_MODELS = gql`
//   query {
//     deviceModel: allDeviceModels {
//       id
//       model_name
//     }
//   }
// `
// const GET_ACCESSORY = gql`
//   query {
//     accessoryDetails: getAllAccessoryTypes {
//       id
//       accessoryName
//     }
//   }
// `
// const GET_SIM_PROVIDER = gql`
//   query {
//     simDetails: allServiceProviders {
//       id
//       name
//     }
//   }
// `
// const GET_BILLING_FREQUENCY = gql`
//   query getAllBillingFrequency($billingModeId: Int!) {
//     getAllBillingFrequency(billingModeId: $billingModeId) {
//       id
//       frequency
//       billingModeId
//       numberOfMonths
//     }
//   }
// `

// const style = theme => ({
//   // textField: {
//   //   marginLeft: theme.spacing.unit * 2,
//   //   marginRight: theme.spacing.unit * 2,
//   //   width: '100%'
//   // }
//   // root: {
//   //   padding: theme.spacing.unit * 1,
//   //   flexGrow: 1
//   // },
//   // input: {
//   //   display: 'flex',
//   //   padding: 0
//   // }
//   card: {
//     overflow: 'visible'
//   },
//   italicizedText: {
//     fontStyle: 'italic'
//   },
//   fileDownloadIcon: {
//     marginLeft: theme.spacing.unit,
//     marginRight: -theme.spacing.unit
//   },
//   wrapFileName: {
//     overflow: 'hidden',
//     whiteSpace: 'nowrap',
//     textOverflow: 'ellipsis',
//     maxWidth: '250px'
//   },
//   cardHeaderAction: {
//     marginTop: '0px',
//     marginRight: '-8px'
//   },
//   selectSytle: {
//     width: '80%'
//   },
//   dividerStyle: {
//     margin: '10px 0px 0 0'
//   }
// })

// function SubscriptionDetails(props) {
//   const { classes, clientDetails } = props
//   const {
//     billingMode: { id }
//   } = clientDetails
//   console.log('client deatails from :', id, clientDetails)
//   console.log('thththht', props)

//   return (
//     <Query
//       query={GET_BILLING_FREQUENCY}
//       variables={{
//         billingModeId: id
//       }}
//     >
//       {({ loading, error, data }) => {
//         if (loading) return 'Loading...'
//         if (error) return `Error!: ${error}`

//         const billingFrequencies = data.getAllBillingFrequency.map(billFrq => ({
//           value: billFrq.id,
//           label: billFrq.frequency
//         }))

//         return (
//           <Query query={GET_BILLING_MODE}>
//             {({ loading, error, data: { billingMode } }) => {
//               if (loading) return 'Loading...'
//               if (error) return `Error!: ${error}`

//               const billingModes = billingMode.map(billingMode => ({
//                 value: billingMode.id,
//                 label: billingMode.billingMode
//               }))

//               return (
//                 <Query query={GET_DEVICE_MODELS}>
//                   {({ loading, error, data: { deviceModel } }) => {
//                     if (loading) return 'Loading...'
//                     if (error) return `Error!: ${error}`

//                     const deviceModels = deviceModel.map(deviceModel => ({
//                       value: deviceModel.id,
//                       label: deviceModel.model_name
//                     }))

//                     return (
//                       <Query query={GET_ACCESSORY}>
//                         {({ loading, error, data: { accessoryDetails } }) => {
//                           if (loading) return 'Loading...'
//                           if (error) return `Error!: ${error}`

//                           const accessoryModels = accessoryDetails.map(
//                             accessoryDetails => ({
//                               value: accessoryDetails.id,
//                               label: accessoryDetails.accessoryName
//                             })
//                           )

//                           return (
//                             <Query query={GET_SIM_PROVIDER}>
//                               {({ loading, error, data: { simDetails } }) => {
//                                 if (loading) return 'Loading...'
//                                 if (error) return `Error!: ${error}`

//                                 const simProviders = simDetails.map(
//                                   simDetails => ({
//                                     value: simDetails.id,
//                                     label: simDetails.name
//                                   })
//                                 )
//                                 return (
//                                   <Card className={classes.card}>
//                                     <CardHeader
//                                       title="Subscription Details"
//                                       subheader="All fields marked with (*) are mandatory"
//                                       subheaderTypographyProps={{
//                                         className: classes.italicizedText
//                                       }}
//                                       classes={{
//                                         action: classes.cardHeaderAction
//                                       }}
//                                       action={
//                                         <Fragment>
//                                           <input
//                                             accept=".pdf"
//                                             id="contained-button-pi-upload"
//                                             type="file"
//                                             style={{
//                                               display: 'none'
//                                             }}
//                                             onChange={props.handlePIUpload}
//                                           />
//                                           {/* eslint-disable */}
//                                           <label htmlFor="contained-button-pi-upload">
//                                             <Button
//                                               variant="contained"
//                                               color="secondary"
//                                               component="span"
//                                               // disabled
//                                             >
//                                               {props.isPIUploading ? (
//                                                 <CircularProgress
//                                                   size={15}
//                                                   color="inherit"
//                                                 />
//                                               ) : (
//                                                 <span
//                                                   className={
//                                                     classes.wrapFileName
//                                                   }
//                                                 >
//                                                   {props.PIFileName === null
//                                                     ? 'Upload PI'
//                                                     : props.PIFileName}
//                                                 </span>
//                                               )}
//                                               {props.isPIUploading ||
//                                               props.PIFileName ? null : (
//                                                 <FileDownloadIcon
//                                                   className={
//                                                     classes.fileDownloadIcon
//                                                   }
//                                                 />
//                                               )}
//                                             </Button>
//                                           </label>
//                                         </Fragment>
//                                       }
//                                     />
//                                     <CardContent>
//                                       <Grid container spacing={16}>
//                                         {/* <Grid item xs={12}>
//                                     <Grid container alignItems="center">
//                                       <Grid item xs={12} md={3}>
//                                         <Select
//                                           className={classes.selectSytle}
//                                           options={billingFrequencies}
//                                           value={props.billingFrequency}
//                                           onChange={props.handleSelectChange(
//                                             'billingFrequency'
//                                           )}
//                                           placeholder="Billing Frequency *"
//                                         />
//                                       </Grid>
//                                       <Grid item xs={12} md={3}>
//                                         <TextField
//                                           required
//                                           id="salesRemarks"
//                                           label="Sales Remarks"
//                                           value={props.salesRemarks}
//                                           onChange={
//                                             props.handleSalesRemarksChange
//                                           }
//                                           margin="none"
//                                         />
//                                       </Grid>
//                                       <Grid item xs={12} md={3}>
//                                         <Select
//                                           className={classes.selectSytle}
//                                           options={props.gstRates}
//                                           value={props.gstRate}
//                                           onChange={props.handleSelectChange(
//                                             'gstRate'
//                                           )}
//                                           placeholder="Select GST Rate *"
//                                         />
//                                       </Grid>
//                                     </Grid>
//                                   </Grid> */}

//                                         {/* Divider Line */}
//                                         {/* <Grid item xs={12}>
//                                     <Divider className={classes.dividerStyle} />
//                                   </Grid> */}
//                                         {/* Software Row */}
//                                         <Grid item xs={12}>
//                                           <Grid
//                                             container
//                                             alignItems="baseline"
//                                             spacing={8}
//                                           >
//                                             <Grid item xs={12}>
//                                               <Typography variant="body1">
//                                                 Software
//                                               </Typography>
//                                             </Grid>
//                                             <Grid
//                                               container
//                                               justify="flex-start"
//                                               alignItems="flex-end"
//                                             >
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   disabled
//                                                   label="AquilaTrack Software"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="softwareQuantity"
//                                                   label="Software Quantity *"
//                                                   value={props.softwareQuantity}
//                                                   onChange={props.handleChange(
//                                                     'softwareQuantity'
//                                                   )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="amount"
//                                                   type="number"
//                                                   label="Software charges*"
//                                                   value={
//                                                     props.deviceTrackingCharges
//                                                   }
//                                                   onChange={props.handleChange(
//                                                     'deviceTrackingCharges'
//                                                   )}
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingModes}
//                                                   value={props.billingMode}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingMode'
//                                                   )}
//                                                   placeholder="Billing Mode *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingFrequencies}
//                                                   value={props.billingFrequency}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingFrequency'
//                                                   )}
//                                                   placeholder="Billing Frequency *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="warrantyPeriod"
//                                                   label="Warranty Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Credit Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Billed Upto *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="text"
//                                                   // inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>

//                                               <Grid item xs={12} md={12}>
//                                                 <label>
//                                                   <Checkbox
//                                                     name="perpetual"
//                                                     defaultChecked={true}
//                                                     value={props.perpetual}
//                                                     onClick={
//                                                       props.handlePerptualCheckbox
//                                                     }
//                                                   />
//                                                   <span
//                                                   // style={{
//                                                   //   fontSize: '20px'
//                                                   // }}
//                                                   >
//                                                     Perptual Billing
//                                                   </span>
//                                                 </label>
//                                               </Grid>
//                                               {props.perpetual && (
//                                                 <Grid item xs={12} sm={3}>
//                                                   <TextField
//                                                     // id="creditPeriod"
//                                                     label="Period *"
//                                                     value={
//                                                       props.softwareQuantity
//                                                     }
//                                                     // onChange={props.handleChange(
//                                                     //   'softwareQuantity'
//                                                     // )}
//                                                     type="number"
//                                                     // inputProps={{ min: 0 }}
//                                                     margin="none"
//                                                   />
//                                                 </Grid>
//                                               )}
//                                               <Button
//                                                 variant="contained"
//                                                 color="secondary"
//                                                 component="span"
//                                               >
//                                                 Add +
//                                               </Button>

//                                               {/* <Grid item xs={12} sm={3}>
//                                                 <Typography variant="body1">
//                                                   Total Amount per month (excl
//                                                   GST): &nbsp;
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                   &#8377;{' '}
//                                                   {console.log(
//                                                     props.totalAmountSoftware
//                                                   )}
//                                                   {isNaN(
//                                                     parseInt(
//                                                       props.totalAmountSoftware,
//                                                       10
//                                                     )
//                                                   )
//                                                     ? '-'
//                                                     : props.totalAmountSoftware}
//                                                 </Typography>
//                                               </Grid> */}
//                                             </Grid>
//                                           </Grid>
//                                         </Grid>

//                                         {/* Divider Line */}
//                                         <Grid item xs={12}>
//                                           <Divider
//                                             className={classes.dividerStyle}
//                                           />
//                                         </Grid>

//                                         {/* Device Row */}
//                                         <Grid item xs={12}>
//                                           <Grid
//                                             container
//                                             alignItems="baseline"
//                                             spacing={8}
//                                           >
//                                             <Grid item xs={12}>
//                                               <Typography variant="body1">
//                                                 Devices
//                                               </Typography>
//                                             </Grid>
//                                             <Grid
//                                               container
//                                               justify="flex-start"
//                                               alignItems="flex-end"
//                                             >
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={deviceModels}
//                                                   value={props.deviceModel}
//                                                   onChange={props.handleSelectChange(
//                                                     'deviceModel'
//                                                   )}
//                                                   placeholder="Select Model *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="quantity"
//                                                   label="Device Quantity *"
//                                                   value={props.totalQuantity}
//                                                   onChange={props.handleChange(
//                                                     'deviceQuantity'
//                                                   )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="hardwareCharges"
//                                                   type="number"
//                                                   label="Hardware Charges *"
//                                                   value={props.hardwareCharges}
//                                                   onChange={props.handleChange(
//                                                     'hardwareCharges'
//                                                   )}
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingModes}
//                                                   value={props.billingMode}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingMode'
//                                                   )}
//                                                   placeholder="Billing Mode *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingFrequencies}
//                                                   value={props.billingFrequency}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingFrequency'
//                                                   )}
//                                                   placeholder="Billing Frequency *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="warrantyPeriod"
//                                                   label="Warranty Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Credit Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Billed Upto *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="text"
//                                                   // inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>

//                                               <Grid item xs={12} md={12}>
//                                                 <label>
//                                                   <Checkbox
//                                                     name="perpetual"
//                                                     defaultChecked={true}
//                                                     value={props.perpetual}
//                                                     onClick={
//                                                       props.handlePerptualCheckbox
//                                                     }
//                                                   />
//                                                   <span
//                                                   // style={{
//                                                   //   fontSize: '20px'
//                                                   // }}
//                                                   >
//                                                     Perptual Billing
//                                                   </span>
//                                                 </label>
//                                               </Grid>
//                                               {props.perpetual && (
//                                                 <Grid item xs={12} sm={3}>
//                                                   <TextField
//                                                     // id="creditPeriod"
//                                                     label="Period *"
//                                                     value={
//                                                       props.softwareQuantity
//                                                     }
//                                                     // onChange={props.handleChange(
//                                                     //   'softwareQuantity'
//                                                     // )}
//                                                     type="number"
//                                                     // inputProps={{ min: 0 }}
//                                                     margin="none"
//                                                   />
//                                                 </Grid>
//                                               )}
//                                               <Button
//                                                 variant="contained"
//                                                 color="secondary"
//                                                 component="span"
//                                               >
//                                                 Add +
//                                               </Button>

//                                               {/* <Grid item xs={12} sm={3}>
//                                                 <Typography variant="body1">
//                                                   Total Amount (excl GST):
//                                                   &nbsp;
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                   &#8377;{' '}
//                                                   {console.log(
//                                                     props.totalAmountHardware
//                                                   )}
//                                                   {isNaN(
//                                                     parseInt(
//                                                       props.totalAmountHardware,
//                                                       10
//                                                     )
//                                                   )
//                                                     ? '-'
//                                                     : props.totalAmountHardware}
//                                                 </Typography>
//                                               </Grid> */}
//                                             </Grid>
//                                           </Grid>
//                                         </Grid>

//                                         {/* Divider Line */}
//                                         <Grid item xs={12}>
//                                           <Divider
//                                             className={classes.dividerStyle}
//                                           />
//                                         </Grid>

//                                         {/* Accessories Row */}
//                                         <Grid item xs={12}>
//                                           <Grid
//                                             container
//                                             alignItems="baseline"
//                                             spacing={8}
//                                           >
//                                             <Grid item xs={12}>
//                                               <Typography variant="body1">
//                                                 Accessories
//                                               </Typography>
//                                             </Grid>
//                                             <Grid
//                                               container
//                                               justify="flex-start"
//                                               alignItems="flex-end"
//                                             >
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={accessoryModels}
//                                                   value={props.accessoryModel}
//                                                   onChange={props.handleSelectChange(
//                                                     'accessoryModel'
//                                                   )}
//                                                   placeholder="Select Type"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="accessoryQuantity"
//                                                   label="Quantity"
//                                                   value={
//                                                     props.accessoryQuantity
//                                                   }
//                                                   onChange={props.handleChange(
//                                                     'accessoryQuantity'
//                                                   )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="accessoryCharges"
//                                                   label="Accessory Charges"
//                                                   type="number"
//                                                   value={props.accessoryCharges}
//                                                   onChange={props.handleChange(
//                                                     'accessoryCharges'
//                                                   )}
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingModes}
//                                                   value={props.billingMode}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingMode'
//                                                   )}
//                                                   placeholder="Billing Mode *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingFrequencies}
//                                                   value={props.billingFrequency}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingFrequency'
//                                                   )}
//                                                   placeholder="Billing Frequency *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="warrantyPeriod"
//                                                   label="Warranty Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Credit Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Billed Upto *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="text"
//                                                   // inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>

//                                               <Grid item xs={12} md={12}>
//                                                 <label>
//                                                   <Checkbox
//                                                     name="perpetual"
//                                                     defaultChecked={true}
//                                                     value={props.perpetual}
//                                                     onClick={
//                                                       props.handlePerptualCheckbox
//                                                     }
//                                                   />
//                                                   <span
//                                                   // style={{
//                                                   //   fontSize: '20px'
//                                                   // }}
//                                                   >
//                                                     Perptual Billing
//                                                   </span>
//                                                 </label>
//                                               </Grid>
//                                               {props.perpetual && (
//                                                 <Grid item xs={12} sm={3}>
//                                                   <TextField
//                                                     // id="creditPeriod"
//                                                     label="Period *"
//                                                     value={
//                                                       props.softwareQuantity
//                                                     }
//                                                     // onChange={props.handleChange(
//                                                     //   'softwareQuantity'
//                                                     // )}
//                                                     type="number"
//                                                     // inputProps={{ min: 0 }}
//                                                     margin="none"
//                                                   />
//                                                 </Grid>
//                                               )}
//                                               <Button
//                                                 variant="contained"
//                                                 color="secondary"
//                                                 component="span"
//                                               >
//                                                 Add +
//                                               </Button>

//                                               {/* <Grid item xs={12} sm={3}>
//                                                 <Typography variant="body1">
//                                                   Total Amount (excl GST):
//                                                   &nbsp;
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                   &#8377;{' '}
//                                                   {console.log(
//                                                     props.totalAmountAccessory
//                                                   )}
//                                                   {isNaN(
//                                                     parseInt(
//                                                       props.totalAmountAccessory,
//                                                       10
//                                                     )
//                                                   )
//                                                     ? '-'
//                                                     : props.totalAmountAccessory}
//                                                 </Typography>
//                                               </Grid> */}
//                                             </Grid>
//                                           </Grid>
//                                         </Grid>

//                                         {/* Divider Line */}
//                                         <Grid item xs={12}>
//                                           <Divider
//                                             className={classes.dividerStyle}
//                                           />
//                                         </Grid>

//                                         {/* Sims Row */}
//                                         <Grid item xs={12}>
//                                           <Grid
//                                             container
//                                             alignItems="baseline"
//                                             spacing={8}
//                                           >
//                                             <Grid item xs={12}>
//                                               <Typography variant="body1">
//                                                 SIM Cards
//                                               </Typography>
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <Select
//                                                 className={classes.selectSytle}
//                                                 options={simProviders}
//                                                 value={props.simModel}
//                                                 onChange={props.handleSelectChange(
//                                                   'simModel'
//                                                 )}
//                                                 placeholder="Select Provider"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="simQuantity"
//                                                 label="Quantity"
//                                                 value={props.simQuantity}
//                                                 onChange={props.handleChange(
//                                                   'simQuantity'
//                                                 )}
//                                                 type="number"
//                                                 inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="simCharges"
//                                                 type="number"
//                                                 label="Annual Sim Charges"
//                                                 value={props.simCharges}
//                                                 onChange={props.handleChange(
//                                                   'simCharges'
//                                                 )}
//                                                 inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <Select
//                                                 className={classes.selectSytle}
//                                                 options={billingModes}
//                                                 value={props.billingMode}
//                                                 onChange={props.handleSelectChange(
//                                                   'billingMode'
//                                                 )}
//                                                 placeholder="Billing Mode *"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} md={3}>
//                                               <Select
//                                                 className={classes.selectSytle}
//                                                 options={billingFrequencies}
//                                                 value={props.billingFrequency}
//                                                 onChange={props.handleSelectChange(
//                                                   'billingFrequency'
//                                                 )}
//                                                 placeholder="Billing Frequency *"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="warrantyPeriod"
//                                                 label="Warranty Period *"
//                                                 value={props.softwareQuantity}
//                                                 // onChange={props.handleChange(
//                                                 //   'softwareQuantity'
//                                                 // )}
//                                                 type="number"
//                                                 inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="creditPeriod"
//                                                 label="Credit Period *"
//                                                 value={props.softwareQuantity}
//                                                 // onChange={props.handleChange(
//                                                 //   'softwareQuantity'
//                                                 // )}
//                                                 type="number"
//                                                 inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="creditPeriod"
//                                                 label="Billed Upto *"
//                                                 value={props.softwareQuantity}
//                                                 // onChange={props.handleChange(
//                                                 //   'softwareQuantity'
//                                                 // )}
//                                                 type="text"
//                                                 // inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>

//                                             <Grid item xs={12} md={12}>
//                                               <label>
//                                                 <Checkbox
//                                                   name="perpetual"
//                                                   defaultChecked={true}
//                                                   value={props.perpetual}
//                                                   onClick={
//                                                     props.handlePerptualCheckbox
//                                                   }
//                                                 />
//                                                 <span
//                                                 // style={{
//                                                 //   fontSize: '20px'
//                                                 // }}
//                                                 >
//                                                   Perptual Billing
//                                                 </span>
//                                               </label>
//                                             </Grid>
//                                             {props.perpetual && (
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   // id="creditPeriod"
//                                                   label="Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   // inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                             )}
//                                             <Button
//                                               variant="contained"
//                                               color="secondary"
//                                               component="span"
//                                             >
//                                               Add +
//                                             </Button>

//                                             {/* <Grid item xs={12} sm={3}>
//                                               <Typography variant="body1">
//                                                 Total Amount per annum (excl
//                                                 GST): &nbsp;
//                                               </Typography>
//                                               <Typography variant="body2">
//                                                 &#8377;{' '}
//                                                 {console.log(
//                                                   props.totalAmountSim
//                                                 )}
//                                                 {isNaN(
//                                                   parseInt(
//                                                     props.totalAmountSim,
//                                                     10
//                                                   )
//                                                 )
//                                                   ? '-'
//                                                   : props.totalAmountSim}
//                                               </Typography>
//                                             </Grid> */}
//                                           </Grid>
//                                         </Grid>
//                                       </Grid>
//                                     </CardContent>

//                                     <CardActions>
//                                       <Button
//                                         color="secondary"
//                                         variant="raised"
//                                         onClick={props.handleSaveClick}
//                                         disabled={props.isSaveButtonDisabled}
//                                       >
//                                         Save
//                                       </Button>
//                                       <Button
//                                         color="secondary"
//                                         onClick={props.handleCancelClick}
//                                       >
//                                         Cancel
//                                       </Button>
//                                     </CardActions>
//                                   </Card>
//                                 )
//                               }}
//                             </Query>
//                           )
//                         }}
//                       </Query>
//                     )
//                   }}
//                 </Query>
//               )
//             }}
//           </Query>
//         )
//       }}
//     </Query>
//   )
// }

// SubscriptionDetails.propTypes = {
//   classes: PropTypes.object.isRequired
// }

// export default withStyles(style)(withApollo(SubscriptionDetails))
import React, { Fragment, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import FileDownloadIcon from '@material-ui/icons/FileDownload'
import Select from 'react-select'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Divider from '@material-ui/core/Divider'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import getLoginId from '../../../utils/getLoginId'

const GET_BILLING_MODE = gql`
  query {
    billingMode: getAllBillingMode {
      id
      billingMode
    }
  }
`
const GET_DEVICE_MODELS = gql`
  query {
    deviceModel: allDeviceModels {
      id
      model_name
    }
  }
`
const GET_ACCESSORY = gql`
  query {
    accessoryDetails: getAllAccessoryTypes {
      id
      accessoryName
    }
  }
`
const GET_SIM_PROVIDER = gql`
  query {
    simDetails: allServiceProviders {
      id
      name
    }
  }
`
const GET_BILLING_FREQUENCY = gql`
  query getAllBillingFrequency($billingModeId: Int!) {
    getAllBillingFrequency(billingModeId: $billingModeId) {
      id
      frequency
      billingModeId
      numberOfMonths
    }
  }
`

const style = theme => ({
  // textField: {
  //   marginLeft: theme.spacing.unit * 2,
  //   marginRight: theme.spacing.unit * 2,
  //   width: '100%'
  // }
  // root: {
  //   padding: theme.spacing.unit * 1,
  //   flexGrow: 1
  // },
  // input: {
  //   display: 'flex',
  //   padding: 0
  // }
  card: {
    overflow: 'visible'
  },
  italicizedText: {
    fontStyle: 'italic'
  },
  fileDownloadIcon: {
    marginLeft: theme.spacing.unit,
    marginRight: -theme.spacing.unit
  },
  wrapFileName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '250px'
  },
  cardHeaderAction: {
    marginTop: '0px',
    marginRight: '-8px'
  },
  selectSytle: {
    width: '80%'
  },
  dividerStyle: {
    margin: '10px 0px 0 0'
  }
})

function SubscriptionDetails(props) {
  const { classes, clientDetails } = props
  const {
    billingMode: { id }
  } = clientDetails
  console.log('client deatails from :', id, clientDetails)

  return (
    <Query
      query={GET_BILLING_FREQUENCY}
      variables={{
        billingModeId: id
      }}
    >
      {({ loading, error, data }) => {
        if (loading) return 'Loading...'
        if (error) return `Error!: ${error}`

        const billingFrequencies = data.getAllBillingFrequency.map(billFrq => ({
          value: billFrq.id,
          label: billFrq.frequency
        }))

        return (
          <Query query={GET_DEVICE_MODELS}>
            {({ loading, error, data: { deviceModel } }) => {
              if (loading) return 'Loading...'
              if (error) return `Error!: ${error}`

              const deviceModels = deviceModel.map(deviceModel => ({
                value: deviceModel.id,
                label: deviceModel.model_name
              }))

              return (
                <Query query={GET_ACCESSORY}>
                  {({ loading, error, data: { accessoryDetails } }) => {
                    if (loading) return 'Loading...'
                    if (error) return `Error!: ${error}`

                    const accessoryModels = accessoryDetails.map(
                      accessoryDetails => ({
                        value: accessoryDetails.id,
                        label: accessoryDetails.accessoryName
                      })
                    )

                    return (
                      <Query query={GET_SIM_PROVIDER}>
                        {({ loading, error, data: { simDetails } }) => {
                          if (loading) return 'Loading...'
                          if (error) return `Error!: ${error}`

                          const simProviders = simDetails.map(simDetails => ({
                            value: simDetails.id,
                            label: simDetails.name
                          }))
                          return (
                            <Card className={classes.card}>
                              <CardHeader
                                title="Subscription Details"
                                subheader="All fields marked with (*) are mandatory"
                                subheaderTypographyProps={{
                                  className: classes.italicizedText
                                }}
                                classes={{ action: classes.cardHeaderAction }}
                                action={
                                  <Fragment>
                                    <input
                                      accept=".pdf"
                                      id="contained-button-pi-upload"
                                      type="file"
                                      style={{
                                        display: 'none'
                                      }}
                                      onChange={props.handlePIUpload}
                                    />
                                    {/* eslint-disable */}
                                    {/* <label htmlFor="contained-button-pi-upload">
                                      <Button
                                        variant="contained"
                                        color="secondary"
                                        component="span"
                                        disabled
                                      >
                                        {props.isPIUploading ? (
                                          <CircularProgress
                                            size={15}
                                            color="inherit"
                                          />
                                        ) : (
                                          <span
                                            className={classes.wrapFileName}
                                          >
                                            {props.PIFileName === null
                                              ? 'Upload PI'
                                              : props.PIFileName}
                                          </span>
                                        )}
                                        {props.isPIUploading ||
                                        props.PIFileName ? null : (
                                          <FileDownloadIcon
                                            className={classes.fileDownloadIcon}
                                          />
                                        )}
                                      </Button>
                                    </label> */}
                                  </Fragment>
                                }
                              />
                              <CardContent>
                                <Grid container spacing={16}>
                                  <Grid item xs={12}>
                                    <Grid container alignItems="center">
                                      <Grid item xs={12} sm={3}>
                                        <Select
                                          className={classes.selectSytle}
                                          options={billingFrequencies}
                                          value={props.billingFrequency}
                                          onChange={props.handleSelectChange(
                                            'billingFrequency'
                                          )}
                                          placeholder="Billing Frequency *"
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={3}>
                                        <TextField
                                          required
                                          id="salesRemarks"
                                          label="Sales Remarks"
                                          value={props.salesRemarks}
                                          onChange={
                                            props.handleSalesRemarksChange
                                          }
                                          margin="none"
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={3}>
                                        <Select
                                          className={classes.selectSytle}
                                          options={props.gstRates}
                                          value={props.gstRate}
                                          onChange={props.handleSelectChange(
                                            'gstRate'
                                          )}
                                          placeholder="Select GST Rate *"
                                        />
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  {/* Divider Line */}
                                  <Grid item xs={12}>
                                    <Divider className={classes.dividerStyle} />
                                  </Grid>
                                  {/* Software Row */}
                                  <Grid item xs={12}>
                                    <Grid
                                      container
                                      alignItems="baseline"
                                      spacing={8}
                                    >
                                      <Grid item xs={12}>
                                        <Typography variant="body1">
                                          Software
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        container
                                        justify="flex-start"
                                        alignItems="flex-end"
                                      >
                                        <Grid item xs={12} sm={3}>
                                          <TextField
                                            disabled
                                            label="AquilaTrack Software"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <TextField
                                            id="softwareQuantity"
                                            label="Software Quantity *"
                                            value={props.softwareQuantity}
                                            onChange={props.handleChange(
                                              'softwareQuantity'
                                            )}
                                            type="number"
                                            inputProps={{ min: 0 }}
                                            margin="none"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <TextField
                                            id="amount"
                                            type="number"
                                            label="Software charges*"
                                            value={props.deviceTrackingCharges}
                                            onChange={props.handleChange(
                                              'deviceTrackingCharges'
                                            )}
                                            inputProps={{ min: 0 }}
                                            margin="none"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <Typography variant="body1">
                                            Total Amount per month (excl GST):
                                            &nbsp;
                                          </Typography>
                                          <Typography variant="body2">
                                            &#8377;{' '}
                                            {console.log(
                                              props.totalAmountSoftware
                                            )}
                                            {isNaN(
                                              parseInt(
                                                props.totalAmountSoftware,
                                                10
                                              )
                                            )
                                              ? '-'
                                              : props.totalAmountSoftware}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  {/* Divider Line */}
                                  <Grid item xs={12}>
                                    <Divider className={classes.dividerStyle} />
                                  </Grid>

                                  {/* Device Row */}
                                  <Grid item xs={12}>
                                    <Grid
                                      container
                                      alignItems="baseline"
                                      spacing={8}
                                    >
                                      <Grid item xs={12}>
                                        <Typography variant="body1">
                                          Devices
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        container
                                        justify="flex-start"
                                        alignItems="flex-end"
                                      >
                                        <Grid item xs={12} sm={3}>
                                          <Select
                                            className={classes.selectSytle}
                                            options={deviceModels}
                                            value={props.deviceModel}
                                            onChange={props.handleSelectChange(
                                              'deviceModel'
                                            )}
                                            placeholder="Select Model *"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <TextField
                                            id="quantity"
                                            label="Device Quantity *"
                                            value={props.totalQuantity}
                                            onChange={props.handleChange(
                                              'deviceQuantity'
                                            )}
                                            type="number"
                                            inputProps={{ min: 0 }}
                                            margin="none"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <TextField
                                            id="hardwareCharges"
                                            type="number"
                                            label="Hardware Charges *"
                                            value={props.hardwareCharges}
                                            onChange={props.handleChange(
                                              'hardwareCharges'
                                            )}
                                            inputProps={{ min: 0 }}
                                            margin="none"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <Typography variant="body1">
                                            Total Amount (excl GST): &nbsp;
                                          </Typography>
                                          <Typography variant="body2">
                                            &#8377;{' '}
                                            {console.log(
                                              props.totalAmountHardware
                                            )}
                                            {isNaN(
                                              parseInt(
                                                props.totalAmountHardware,
                                                10
                                              )
                                            )
                                              ? '-'
                                              : props.totalAmountHardware}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  {/* Divider Line */}
                                  <Grid item xs={12}>
                                    <Divider className={classes.dividerStyle} />
                                  </Grid>

                                  {/* Accessories Row */}
                                  <Grid item xs={12}>
                                    <Grid
                                      container
                                      alignItems="baseline"
                                      spacing={8}
                                    >
                                      <Grid item xs={12}>
                                        <Typography variant="body1">
                                          Accessories
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        container
                                        justify="flex-start"
                                        alignItems="flex-end"
                                      >
                                        <Grid item xs={12} sm={3}>
                                          <Select
                                            className={classes.selectSytle}
                                            options={accessoryModels}
                                            value={props.accessoryModel}
                                            onChange={props.handleSelectChange(
                                              'accessoryModel'
                                            )}
                                            placeholder="Select Type"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <TextField
                                            id="accessoryQuantity"
                                            label="Quantity"
                                            value={props.accessoryQuantity}
                                            onChange={props.handleChange(
                                              'accessoryQuantity'
                                            )}
                                            type="number"
                                            inputProps={{ min: 0 }}
                                            margin="none"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <TextField
                                            id="accessoryCharges"
                                            label="Accessory Charges"
                                            type="number"
                                            value={props.accessoryCharges}
                                            onChange={props.handleChange(
                                              'accessoryCharges'
                                            )}
                                            inputProps={{ min: 0 }}
                                            margin="none"
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                          <Typography variant="body1">
                                            Total Amount (excl GST): &nbsp;
                                          </Typography>
                                          <Typography variant="body2">
                                            &#8377;{' '}
                                            {console.log(
                                              props.totalAmountAccessory
                                            )}
                                            {isNaN(
                                              parseInt(
                                                props.totalAmountAccessory,
                                                10
                                              )
                                            )
                                              ? '-'
                                              : props.totalAmountAccessory}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  {/* Divider Line */}
                                  <Grid item xs={12}>
                                    <Divider className={classes.dividerStyle} />
                                  </Grid>

                                  {/* Sims Row */}
                                  <Grid item xs={12}>
                                    <Grid
                                      container
                                      alignItems="baseline"
                                      spacing={8}
                                    >
                                      <Grid item xs={12}>
                                        <Typography variant="body1">
                                          SIM Cards
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={3}>
                                        <Select
                                          className={classes.selectSytle}
                                          options={simProviders}
                                          value={props.simModel}
                                          onChange={props.handleSelectChange(
                                            'simModel'
                                          )}
                                          placeholder="Select Provider"
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={3}>
                                        <TextField
                                          id="simQuantity"
                                          label="Quantity"
                                          value={props.simQuantity}
                                          onChange={props.handleChange(
                                            'simQuantity'
                                          )}
                                          type="number"
                                          inputProps={{ min: 0 }}
                                          margin="none"
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={3}>
                                        <TextField
                                          id="simCharges"
                                          type="number"
                                          label="Annual Sim Charges"
                                          value={props.simCharges}
                                          onChange={props.handleChange(
                                            'simCharges'
                                          )}
                                          inputProps={{ min: 0 }}
                                          margin="none"
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={3}>
                                        <Typography variant="body1">
                                          Total Amount per annum (excl GST):
                                          &nbsp;
                                        </Typography>
                                        <Typography variant="body2">
                                          &#8377;{' '}
                                          {console.log(props.totalAmountSim)}
                                          {isNaN(
                                            parseInt(props.totalAmountSim, 10)
                                          )
                                            ? '-'
                                            : props.totalAmountSim}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </CardContent>

                              <CardActions>
                                <Button
                                  color="secondary"
                                  variant="raised"
                                  onClick={props.handleSaveClick}
                                  disabled={
                                    props.isSaveButtonDisabled ||
                                    props.gstRate === 0 ||
                                    props.gstRate === null ||
                                    !props.salesRemarks
                                  }
                                >
                                  Save
                                </Button>
                                <Button
                                  color="secondary"
                                  onClick={props.handleCancelClick}
                                >
                                  Cancel
                                </Button>
                              </CardActions>
                            </Card>
                          )
                        }}
                      </Query>
                    )
                  }}
                </Query>
              )
            }}
          </Query>
        )
      }}
    </Query>
  )
}

SubscriptionDetails.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(style)(withApollo(SubscriptionDetails))



// WEBPACK FOOTER //
// ./src/components/Pages/NewSubscription/subscriptionDetails.jsx